class InfiniteScroll extends HTMLElement {
  constructor() {
    super();
    this.isLoading = false;
    this.productBuffer = [];
    this.productsPerPage = parseInt(this.dataset.productsPerPage, 10) || 24;

    this.addEventListener('click', this.onClickHandler.bind(this));

    if (this.dataset.trigger === 'infinite') {
      new IntersectionObserver(this.handleIntersection.bind(this), { rootMargin: '0px 0px 200px 0px' }).observe(this);
    }

    this.initialGridCheck();
  }

  async initialGridCheck() {
    await new Promise(resolve => setTimeout(resolve, 0));

    const productGrid = document.getElementById('product-grid');
    if (!productGrid) return;

    const initialProductCount = productGrid.querySelectorAll('.flex-grid__item').length;

    if (initialProductCount < this.productsPerPage && this.dataset.url) {
      if (initialProductCount === 0) {
        this.onClickHandler();
      } else {
        this.onClickHandler();
      }
    }
  }

  async onClickHandler() {
    if (this.isLoading || this.classList.contains('disabled')) return;

    this.classList.add('loading');
    this.isLoading = true;

    if (this.dataset.trigger === 'click') {
      await this.loadAndFillGrid();
    } else {
      await this.loadSimple();
    }

    this.isLoading = false;
    this.classList.remove('loading');
  }

  handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);
    this.onClickHandler();
  }

  async loadAndFillGrid() {
    const productGrid = document.getElementById('product-grid');
    if (!productGrid) return;

    const currentProductCount = productGrid.querySelectorAll('.flex-grid__item').length;
    let productsOnCurrentPage = currentProductCount % this.productsPerPage;

    if (currentProductCount > 0 && productsOnCurrentPage === 0) {
      productsOnCurrentPage = 0;
    }

    let productsAddedCount = productsOnCurrentPage;

    const fragment = document.createDocumentFragment();

    while (this.productBuffer.length > 0 && productsAddedCount < this.productsPerPage) {
      const productNode = this.productBuffer.shift();
      fragment.appendChild(productNode);
      productsAddedCount++;
    }

    productGrid.appendChild(fragment);

    let currentUrl = this.dataset.url;

    while (productsAddedCount < this.productsPerPage && currentUrl) {
      const result = await this.fetchProducts(currentUrl);

      if (!result) {
        currentUrl = null;
        break;
      }

      const productsToProcess = result.products;
      currentUrl = result.nextUrl;

      while (productsToProcess.length > 0 && productsAddedCount < this.productsPerPage) {
        const productNode = productsToProcess.shift();
        productGrid.appendChild(productNode);
        productsAddedCount++;
      }

      if (productsToProcess.length > 0) {
        this.productBuffer.push(...productsToProcess);
      }
    }

    if (currentUrl) {
      this.dataset.url = currentUrl;
    } else {
      delete this.dataset.url;
    }

    if (!this.dataset.url && this.productBuffer.length === 0) {
      this.disableButton();
    }
  }

  async loadSimple() {
    const url = this.dataset.url;
    if (!url) {
      this.disableButton();
      return;
    }
    const result = await this.fetchProducts(url);
    if (result) {
      const productGrid = document.getElementById('product-grid');
      const fragment = document.createDocumentFragment();
      result.products.forEach(p => fragment.appendChild(p));
      productGrid.appendChild(fragment);

      if (result.nextUrl) {
        this.dataset.url = result.nextUrl;
      } else {
        this.disableButton();
      }
    } else {
      this.disableButton();
    }
  }

  async fetchProducts(url) {
    try {
      const response = await fetch(url);
      if (!response.ok) throw new Error('Network response was not ok');
      const html = await response.text();
      const parser = new DOMParser().parseFromString(html, 'text/html');

      const productNodes = Array.from(parser.querySelectorAll('#product-grid .flex-grid__item'));
      if (productNodes.length === 0) {
        const nextLoadMore = parser.querySelector('infinite-scroll');
        if (nextLoadMore?.dataset.url) {
          return this.fetchProducts(nextLoadMore.dataset.url);
        }
        return null;
      }

      const nextUrl = parser.querySelector('infinite-scroll')?.dataset.url || null;
      return { products: productNodes, nextUrl: nextUrl };
    } catch (error) {
      console.error('Failed to fetch products:', error);
      return null;
    }
  }

  disableButton() {
    this.classList.add('disabled');
    this.textContent = 'No more products';
    delete this.dataset.url;
  }
}

customElements.define('infinite-scroll', InfiniteScroll);